import(/* webpackMode: "eager" */ "/var/www/kst-frontend-staging/app/own-and-earn/calculator/page.tsx")